import { StaticJsonRpcProvider } from '@ethersproject/providers';

export const rpcProvider = new StaticJsonRpcProvider(process.env.REACT_APP_SERVICE_URL);
